// ssh -R modest-rhino-fit.ngrok-free.app:443:localhost:3000 v2@connect.ngrok-agent.com http
// const ngrokPrefix = "normal-sweet-marmoset"; // selforsaken@gmail.com
// const ngrokPrefix = "modest-rhino-fit"; // human@slvtrs.com
// const ngrokPrefix = "amused-direct-gator"; // github auth
const ngrokPrefix = "slvtrs.ddns.net"; // ddns
import { Platform, Appearance } from "react-native";

import Constants from "expo-constants";
import * as Device from "expo-device";

// import SECRETS from "app/utils/SECRETS";
const SECRETS = { gCalSecret: "" };

let CYCLE = 7;
let STACK_PROGRESS = false;
STACK_PROGRESS = true;

let LOCAL = false;
let FTUE = false;
let DEMO = false;
const WEB = Platform.OS == "web";

if (!WEB) {
  // LOCAL = true
  // DEMO = true
}

let DARK_MODE;
let LIGHT_MODE;

let DEV = true; // == localhost
DEV = false; // == staging
let PROD = false;
// PROD = true // == production

// if(Platform.OS == 'android') DEV = false

let IP = "localhost";
// IP = '192.168.43.248' // blkmrr
// IP = '169.254.67.138'
// IP = 'slvtrs-mb12.local' // rails s -b 0.0.0.0

let PORT = "3003";
PORT = "3000";

let HOST = `${IP}:${PORT}`;

if (Device.isDevice && !WEB && !LOCAL)
  HOST = `${ngrokPrefix}.ngrok-free.app`;
if (!DEV) HOST = `${ngrokPrefix}.ngrok-free.app`;

// if(DEV) HOST = '490f5392a4ef.ngrok-free.app'
let ROOT = `http://${HOST}/`;
let CABLE = `ws://${HOST}/cable`;

if (!DEV) {
  if (ngrokPrefix.includes("ddns.net")) {
    // HOST = `${ngrokPrefix}:${PORT}`;
    HOST = `${ngrokPrefix}`;
    ROOT = `https://${HOST}/`;
    CABLE = `wss://${HOST}/cable`;
  } else {
    HOST = `${ngrokPrefix}.ngrok-free.app`;
    ROOT = `https://${HOST}/`;
    CABLE = `wss://${HOST}/cable`;
  }
}
if (PROD) {
  ROOT = `https://${HOST}/`;
  CABLE = `wss://${HOST}/cable`;
}

const setValues = () => {
  DARK_MODE = false;
  if (!WEB) {
    DARK_MODE = true;
    DARK_MODE = false;
    // const hour = new Date().getHours();
    // if (hour < 7 || hour > 19) {
    //   DARK_MODE = true;
    // }
    // DARK_MODE = true;
    if (Appearance.getColorScheme() === "light") {
      DARK_MODE = false;
    }
  }
  // else {
  try {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      console.log("set dark to true");
      DARK_MODE = true;
    }
  } catch (e) {
    DARK_MODE = true;
  }
  // }
  LIGHT_MODE = !DARK_MODE;
};

const DARK = () => {
  return DARK_MODE;
};

const LIGHT = () => {
  return LIGHT_MODE;
};

const refresh = () => {
  console.log("refresh env values");
  setValues();
  // ENV.DARK/LIGHT captured the load-time values — resync them so consumers
  // reading ENV.DARK after a system theme change see the current scheme
  ENV.DARK = DARK_MODE;
  ENV.LIGHT = LIGHT_MODE;
};

setValues();

const ENV = {
  DEV: DEV,
  PROD: PROD,
  ROOT: ROOT,
  // API: `${ROOT}api/v1/`,
  API: `${ROOT}`,
  CABLE,
  HOST,
  DARK: DARK_MODE,
  LIGHT: LIGHT_MODE,
  // DARK,
  // LIGHT,
  WEB,
  // WEB: false,
  LOCAL,
  FTUE,
  DEMO,
  CYCLE,
  STACK_PROGRESS,
  refresh,
  gCalSecret: SECRETS.gCalSecret,
  autoToken: process.env.EXPO_PUBLIC_AUTO_TOKEN || "",
};

export default ENV;

//--dump
// pg_dump myapp_development > ~/Desktop/mandelbrot_dump.dump
//--restore
/*
rails db:drop
rails db:create
psql myapp_development < ~/Desktop/mandelbrot_dump.dump
rails db:migrate
*/

// {
//   "auto_format_on_save": true,
//   "prettier_cli_path": "/Users/slvtrs/.nvm/versions/node/v14.8.0/bin/prettier",
//   "node_path": "/Users/slvtrs/.nvm/versions/node/v14.8.0/bin/node",
// }

//--publish web
// npx expo export:web
// cd web-build && vercel --prod
// mandelbrot
// https://vercel.com/slvtrs/mandelbrot

// https://stefanbauer.me/tips-and-tricks/edit-files-on-a-remote-server-via-ssh-with-sublime-right-in-your-terminal

// new native build
// eas build --profile preview
// eas build --profile preview --platform ios

// push native ota update
// eas update

// without eas build
// npx expo prebuild --clean
// then build from xcode/android studio
